import { Color } from 'excalibur';

export const subtleTint = (target: Color, strength: number): Color => {
    const s = Math.max(0, Math.min(1, strength));
    const r = Math.round(255 + (target.r - 255) * s);
    const g = Math.round(255 + (target.g - 255) * s);
    const b = Math.round(255 + (target.b - 255) * s);
    return new Color(r, g, b, 255);
}
